/* eslint-disable camelcase */
import * as Yup from 'yup';

export const NOTIFICATION_TABS = {
  ALL: 'All',
  UNSEEN: 'UNSEEN',
};

export const customNotificationValidationSchema = Yup.object({
  title: Yup.string('Enter the Title')
    .max(500, 'Title should be less than 500 characters')
    .required('Title is required')
    .trim(),
  message: Yup.string('Enter the Message')
    .max(2000, 'Message should be less than 2000 characters')
    .required('Message is required')
    .trim(),
  platform_type: Yup.object('')
    .required('Platform Type is required')
    .nullable(),
  imageUrl: Yup.string()
    .nullable() // Allows null or undefined values
    .when('notificationType.id', (notificationTypeId, schema) => {
      const isVideo = notificationTypeId?.[0] === 'VIDEO';
      const schema2 = schema
        .nullable()
        .test(
          'fileType',
          isVideo
            ? 'Only JPG and PNG file formats are allowed'
            : 'Only JPG, PNG, and GIF file formats are allowed',
          (value) => {
            if (!value) return true; // Allow null or empty values
            const fileRegex = isVideo
              ? /\.(jpg|jpeg|png)$/i // VIDEO case: No GIF
              : /\.(jpg|jpeg|png|gif)$/i; // Other cases: Include GIF
            return fileRegex.test(value);
          },
        );
      return isVideo ? schema2.required() : schema2;
    }),
  // imageUrl: Yup.string()
  //   .when('notificationType.id', {
  //     is: 'VIDEO',
  //     then: (schema) => schema.required('Image is required'),
  //   })
  //   .nullable() // Allows null or undefined
  //   .test(
  //     'fileType',
  //     'Only JPG, PNG and GIF file formats are allowed',
  //     (value) =>
  //       !value || // Pass validation if no value is provided
  //       /\.(jpg|jpeg|png|gif)$/i.test(value), // Check if the value matches the allowed file types
  //   ),
  videoUrl: Yup.string()
    .nullable() // Allows null or undefined
    .test(
      'fileType',
      'Only Video file formats are allowed',
      (value) =>
        !value || // Pass validation if no value is provided
        /\.(mp4)$/i.test(value), // Check if the value matches the allowed file types
    ),
  // platform_type: Yup.object().shape({
  //   id: Yup.string().required(),
  //   label: Yup.string().required(),
  // }),
  // .required('Description Image is required')
  // imageUrl: Yup.mixed().test(
  //   'fileType',
  //   'Only JPG, PNG types are allowed',
  //   (value) => !value || /\.(jpg|jpeg|png)$/i.test(value),
  // ),
});

export const PlATFORM_TYPE = [
  { id: 'ALL', label: 'All' },
  { id: 'web', label: 'WEB' },
  { id: 'android', label: 'Android' },
  { id: 'ios', label: 'IOS' },
];

export const SCHEDULER_INTERVALS = [
  { id: '7_DAY', label: '7 Day' },
  { id: '15_DAY', label: '15 Day' },
  { id: '30_DAY', label: '30 Day' },
];
